import { useState } from 'react'
import styled from 'styled-components'
import { Snackbar } from '@mui/material'
import { Alert } from '@mui/material'

interface Props {
  children: JSX.Element | string
  className?: string
  duration?: number
  handleClose?: () => void
}

export default function SuccessMessage({ children, className, duration = 5000, handleClose }: Props): JSX.Element {
  const [open, setOpen] = useState<boolean>(true)

  const onClose = () => {
    setOpen(false)
    handleClose && handleClose()
  }

  return (
    <Snackbar
      className={className}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      onClose={onClose}
      key="bottomcenter"
      autoHideDuration={duration}
    >
      <Message severity="success" className={className}>
        {children}
      </Message>
    </Snackbar>
  )
}

const Message = styled(Alert)`
  background-color: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.customPalette.light};
  margin-bottom: 10px;

  & .MuiAlert-icon {
    color: ${(props) => props.theme.customPalette.light};
  }
`
